//#region src/locales/en/common.json
var e = {
	affiliate_badge: { made_with: "Powered by" },
	breadcrumbs: {
		current: "Current",
		navigation_path: "Navigation path"
	},
	components: { offer_price: { price_plans: {
		limited_with_limit_of_payments: "<b>{{ amount }}</b> / {{ interval }} - <b>{{ count }}</b> times",
		trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then",
		trial_period_price: "Free",
		unlimited_new: "<b>{{amount}}</b> every {{interval}}"
	} } },
	contact_slug: {
		city: "City",
		company_name: "Company name",
		country: "Country",
		email: "Email",
		first_name: "First name",
		last_name: "Last name",
		neighborhood: "Neighborhood",
		phone_number: "Phone number",
		postal_code: "Postal code",
		state_province: "State/Province",
		street_address: "Street address",
		street_number: "Street number",
		tax_number: "Tax number"
	},
	copy_clipboard: "Copied to clipboard",
	copy_clipboard_error: "Failed to copy text",
	date_picker: {
		all_time: "All time",
		apply: "Apply",
		clear: "Clear",
		date_and_time_placeholder: "Date and time",
		date_filter_title: "Date Filter",
		date_placeholder: "Date",
		from: "From",
		last_3_months: "Last 3 months",
		last_30_days: "Last 30 days",
		last_month: "Last month",
		last_pool_period: "Last pool evaluation period",
		this_month: "This month",
		time: "Time",
		title_dates: "Dates",
		to: "To"
	},
	error: "Error",
	form_select: {
		done: "Done",
		empty_list: "It looks like this list is empty",
		select: "Select"
	},
	global: { more: "More" },
	including_tax: "Includes {{percent}}% tax ({{amount}})",
	input: {
		phone_number: "Phone number",
		phone_search: "Search",
		search: "Search",
		url: {
			mail: "Mail",
			site: "Site",
			tel: "Tel"
		}
	},
	locale: {
		albania: "Albanian",
		arabic: "Arabic",
		chinese: "Chinese",
		czech: "Czech",
		danish: "Danish",
		dutch: "Dutch",
		english: "English",
		french: "French",
		german: "German",
		greek: "Greek",
		hindi: "Hindi",
		hungarian: "Hungarian",
		indonesian: "Indonesian",
		italian: "Italiano",
		japanese: "Japanese",
		norwegian: "Norwegian",
		polish: "Polish",
		portuguese: "Portuguese",
		romanian: "Romanian",
		russian: "Russian",
		serbian: "Serbian",
		slovak: "Slovak",
		slovenian: "Slovenian",
		spanish: "Spanish",
		swedish: "Swedish",
		thai: "Thai",
		turkish: "Turkish",
		ukrainian: "Ukrainian"
	},
	order_summary: "Order summary",
	payment: {
		cash_on_delivery: "Cash on delivery",
		dlocal_boleto: "Boleto (Dlocal)",
		dlocal_card: "Credit cards (Dlocal)",
		dlocal_pix: "Pix (Dlocal)",
		flutterwave: "Flutterwave",
		gocardless: "Gocardless",
		mercadopago_boleto: "Boleto (Mercado Pago)",
		mercadopago_card: "Credit cards (Mercado Pago)",
		mercadopago_pix: "PIX (Mercado Pago)",
		mollie: "Mollie",
		paypal_connect: "Connect PayPal",
		paypal_edit_organization_name: "Edit organization name",
		paypal_rest: "PayPal",
		paypal_soap: "PayPal",
		paystack_card: "Credit cards (Paystack)",
		price_plan: "Plan",
		razorpay: "Razorpay",
		secure_and_pay: "Secure and Pay",
		square: "Square",
		square_card: {
			consent_required: "You must consent to card storage to continue.",
			consent_text: "I authorize the storage of my card details for future payments.",
			load_error: "The card form could not be loaded. Try again or choose another payment method.",
			retry: "Try again"
		},
		stripe_applepay: "Apple Pay",
		stripe_bancotact: "Bancontact (Stripe)",
		stripe_card: "Credit or debit card",
		stripe_ideal: "iDeal (Stripe)",
		stripe_klarna: "Klarna (Stripe)",
		stripe_mbway: "MB WAY (Stripe)",
		stripe_multibanco: "Multibanco (Stripe)",
		xendit: { "3ds": "3D-Secure" },
		xendit_card: "Credit cards (Xendit)"
	},
	payment_inputs: {
		card_holder_placeholder: "Card holder",
		card_number_placeholder: "Card number",
		cvc_placeholder: "CVC",
		date_out_of_range: "Expiry date cannot be in the past",
		empty_card_holder: "Enter a card holder name",
		empty_card_number: "Enter a card number",
		empty_cvc: "Enter a CVC",
		empty_expiry_date: "Enter an expiry date",
		expiry_data_placeholder: "MM/YY",
		invalid_card_holder: "Enter a valid card holder name",
		invalid_card_number: "Card number is invalid",
		invalid_cvc: "CVC is invalid",
		invalid_expiry_date: "Expiry date is invalid",
		month_out_of_range: "Expiry month must be between 01 and 12",
		year_out_of_range: "Expiry year cannot be in the past"
	},
	"Payment-method": "Payment method",
	price_plan: {
		interval: {
			day: "day",
			day_plural: "<b>{{count}}</b> days",
			month: "month",
			month_plural: "<b>{{count}}</b> months",
			week: "week",
			week_plural: "<b>{{count}}</b> weeks",
			year: "year",
			year_plural: "<b>{{count}}</b> years"
		},
		trial_period: {
			day: "<b>{{count}}</b> day",
			day_plural: "<b>{{count}}</b> days",
			month: "<b>{{count}}</b> month",
			month_plural: "<b>{{count}}</b> months",
			week: "<b>{{count}}</b> week",
			week_plural: "<b>{{count}}</b> weeks",
			year: "<b>{{count}}</b> year",
			year_plural: "<b>{{count}}</b> years"
		}
	},
	product: "Product",
	quantity: "Quantity",
	"registered-over": "registered over",
	"required-field": "Field is required",
	shipping: {
		condition_label: {
			price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}",
			price_min: "For orders priced at {{min}} {{currency}} or more",
			quantity: "For orders containing between {{min}} to {{max}} items",
			quantity_min: "For orders containing {{min}} or more items",
			weight: "For orders with a total weight between {{min}}g to {{max}}g",
			weight_min: "For orders with a total weight of {{min}}g or more"
		},
		not_available: "Oops! It looks like we don't offer shipping to this location yet",
		shipping_method: "Shipping method"
	},
	shipping_fee: "Shipping fee",
	subtotal: "Subtotal",
	tabbar: { more: "\"More\"" },
	table: {
		bulk_actions: { close: "Close" },
		mobile: {
			cancel: "Cancel",
			select_all: "Select all",
			select_row: "Select row",
			select_row_named: "Select {{row}}"
		},
		pagination: {
			next_page: "Next page",
			previous_page: "Previous page",
			results_per_page: "Results per page"
		},
		sort: "Sort"
	},
	total: "Total",
	total_amount_with_shipping: "Total (including Shipping)",
	total_amount_with_tax: "Total (including tax)",
	total_amount_with_tax_and_shipping: "Total (including tax and Shipping)",
	tracking_code_input: {
		css: { parse: "Invalid CSS syntax" },
		field_error: "The code is not valid",
		html: {
			"abrupt-closing-of-empty-comment": "Abrupt closing of empty comment",
			"duplicate-attribute": "Duplicate attribute",
			"empty-src": "Empty src attribute. The iframe has no source URL. Make sure this is intentional",
			"end-tag-without-matching-open-element": "End tag without matching open element",
			"eof-in-tag": "Unexpected end of file in tag",
			"invalid-first-character-of-tag-name": "Invalid first character of tag name",
			"missing-attribute-value": "Missing attribute value",
			"missing-whitespace-between-attributes": "Missing whitespace between attributes",
			parse: "Invalid HTML markup",
			"unexpected-character-in-attribute-name": "Invalid character in attribute name",
			"unexpected-character-in-unquoted-attribute-value": "Unexpected character after attribute value",
			"unexpected-equals-sign-before-attribute-name": "Unexpected equals sign before attribute name",
			"unexpected-solidus-in-tag": "Unexpected character after / in tag. Expected >"
		},
		invalid: "Invalid code",
		js: { syntax: "Invalid JavaScript syntax" }
	},
	vat: "Sales tax",
	vat_percent: "Sales tax ({{percent}}%)"
}, t = { public_pages_purchase: e };
//#endregion
export { t as default, e as public_pages_purchase };
